import React from "react";
import Link from "next/link";

const Pagination = ({ currentPage, totalPages, setPage, buildHref = () => "#" }) => {
  const windowSize = 5;
  const half = Math.floor(windowSize / 2);

  let startPage = Math.max(1, currentPage - half);
  let endPage = startPage + windowSize - 1;

  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - windowSize + 1);
  }

  const pages = [];
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  const handleClick = (e, page) => {
    if (setPage) {
      setPage(page);
    }
  };

  const handlePrev = (e) => {
    if (setPage && currentPage > 1) {
      setPage(currentPage - 1);
    }
  };

  const handleNext = (e) => {
    if (setPage && currentPage < totalPages) {
      setPage(currentPage + 1);
    }
  };

  if (!totalPages || totalPages <= 0) {
    return null;
  }

  return (
    <div className="flex items-center justify-center gap-1 md:gap-2 my-6">
      {/* Prev */}
      {currentPage > 1 ? (
        <Link
          href={buildHref(currentPage - 1)}
          onClick={handlePrev}
          rel="prev"
          aria-label="Go to previous page"
          className="px-3 py-1 text-sm font-semibold text-gray-700 cursor-pointer hover:text-[#FC9D00] transition-colors duration-200"
        >
          Prev
        </Link>
      ) : (
        <span className="px-3 py-1 text-sm font-semibold text-gray-400 cursor-not-allowed">
          Prev
        </span>
      )}

      {/* Page Numbers */}
      {pages.map((page) => {
        const isActive = currentPage === page;
        return isActive ? (
          <span
            key={page}
            aria-current="page"
            aria-label={`Page ${page}`}
            className="outline-none px-4 md:px-5 py-2 text-[14px] md:text-[16px] font-semibold 
              rounded-md border bg-[#FC9D00] text-white border-[#FC9D00]"
          >
            {page}
          </span>
        ) : (
          <Link
            key={page}
            href={buildHref(page)}
            onClick={(e) => handleClick(e, page)}
            aria-label={`Go to page ${page}`}
            className="outline-none cursor-pointer px-4 md:px-5 py-2 text-[14px] md:text-[16px] font-semibold 
              rounded-md border transition-colors duration-500 ease-in-out
              bg-white text-gray-700 border-[#616777] hover:bg-gray-100 opacity-[.3]"
          >
            {page}
          </Link>
        );
      })}

      {/* Next */}
      {currentPage < totalPages ? (
        <Link
          href={buildHref(currentPage + 1)}
          onClick={handleNext}
          rel="next"
          aria-label="Go to next page"
          className="px-3 py-1 text-sm font-semibold text-gray-700 cursor-pointer hover:text-[#FC9D00] transition-colors duration-200"
        >
          Next
        </Link>
      ) : (
        <span className="px-3 py-1 text-sm font-semibold text-gray-400 cursor-not-allowed">
          Next
        </span>
      )}
    </div>
  );
};

export default Pagination;